export default {
      id: "contact-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#contact-usage",
      toString: function () {
        return this.url;
      }
    }